/* eslint-disable */
document.addEventListener("alpine:init", () => {
    Alpine.data("typeform", () => ({
        btnShow: false,
        btnText: "",
        tfLoaded: false,
        init() {
            const typeformContainer = this.$el;
            const config = {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            };

            const obs = new MutationObserver(mutationList => {
                for (const mutation of mutationList) {
                    const [ childNode ] = mutation?.addedNodes;
                    const typeformBtn = childNode;

                    if (typeformBtn && typeformBtn.nodeName === "BUTTON" ) {
                        this.btnText = typeformBtn.innerText;
                        this.btnShow = true;
                    }

                    this.tfLoaded = true;
                }
            });

            obs.observe(typeformContainer, config);
        },
        openPopup() {
            const typeformBtn = this.$refs?.typeform.querySelector('button:not(.tf-v1-widget-close)');
            if (typeformBtn) typeformBtn.click();
        }
    }));
});